import React from 'react';
import { identifyComponent } from '../../../util';
import { TableHeadRow } from '../TableHeadRow';
import { TableHeadBase } from './Base';
import { TableHeadProps } from './types';

export function TableHead<R>({
  className,
  columns,
  rowComponent: RowComponent = TableHeadRow,
  rowProps = {},
  variant,
}: TableHeadProps<R>) {
  return (
    <TableHeadBase
      data-component="TableHead"
      className={className}
      variant={variant}
      {...identifyComponent('table-head')}
    >
      <RowComponent columns={columns} {...rowProps} />
    </TableHeadBase>
  );
}
